import { isTag, isDocumentNode } from 'anodum';
import { connectedStore } from '../../store';
import selectors from '../selectors';
import constants from '../constants';
import isElementDetached from '../verifiers/is-element-detached';

const injectGlobal = (element, state) => {
  const source = element.getAttribute('src');
  const global = selectors.getGlobalBySource(state, source);
  if (!global || isElementDetached(element)) return null;
  element.insertAdjacentHTML('afterbegin', global.html);
  return element.firstElementChild;
};

const injectGlobals = (staticNode) => {
  const store = connectedStore.get();
  const state = store.getState();

  if (!isDocumentNode(staticNode) && isTag(staticNode, constants.GLOBAL_TAG_NAME)) {
    const insertedElement = injectGlobal(staticNode, state);
    if (!insertedElement) return staticNode;
    injectGlobals(insertedElement);
  } else {
    const globalElements = staticNode.querySelectorAll(`${constants.GLOBAL_TAG_NAME}[src]`);

    globalElements.forEach((globalElement) => {
      const insertedElement = injectGlobal(globalElement, state);
      if (!insertedElement) return;
      injectGlobals(insertedElement);
    });
  }

  return staticNode;
};

export default injectGlobals;
